
function handleFormFills() {
	const inquirySubject = document.getElementById('staehr-sold-out-inquiry-subject')?.getAttribute('data-value') || '';
  
	const autoFills = [
		{
			formId: '376319', // General Inquiry (Sold out form) EN
			fields: [
				{
					fieldId: 'custom#subject1',
					value: inquirySubject,
					isDisabled: true
				},
				// {
				//     fieldId: 'custom#name',
				//     value: 'John',
				//     isDisabled: false
				// },
			],
		},
		{
			formId: '418623', // General Inquiry (Sold out form) DA
			fields: [
				{
					fieldId: 'custom#emne1',
					value: inquirySubject,
					isDisabled: true
				},
			],
		},
		{
			formId: '405268', // General Inquiry (form page) DA
			fields: [
				{
					fieldId: 'custom#subject',
					value: 'General Inquiry',
					isDisabled: true
				},
			],
		},
		{
			formId: '422599', // General Inquiry (form page) EN
			fields: [
				{
					fieldId: 'custom#subject',
					value: 'General Inquiry',
					isDisabled: true
				},
			],
		},
		{
			formId: '376359', // Submit your watch DA
			fields: [
				{
					fieldId: 'custom#subject',
					value: 'Submit your watch',
					isDisabled: true
				},
			],
		},
		{
			formId: '615970', // Submit your watch DA - 2
			fields: [
				{
					fieldId: 'custom#subject',
					value: 'Submit your watch',
					isDisabled: true
				},
			],
		},
		{
			formId: '422600', // Submit your watch EN
			fields: [
				{
					fieldId: 'custom#subject',
					value: 'Submit your watch',
					isDisabled: true
				},
			],
		},
		{
			formId: '405267', // Repair contact form DA
			fields: [
				{
					fieldId: 'custom#subject_2',
					value: 'Repair',
					isDisabled: true
				},
			],
		},
		{
			formId: '422597', // Repair contact form EN
			fields: [
				{
					fieldId: 'custom#subject_2',
					value: 'Repair',
					isDisabled: true
				},
			],
		},
	]

	autoFills.forEach(autoFill => {
		const section = document.querySelector(`div[data-forms-id="forms-root-${autoFill.formId}"]`);
		if (section) {
			setTimeout(() => {

				const formEmbed = section.querySelector('shopify-forms-embed');
				if (formEmbed && formEmbed.shadowRoot) {

					if (autoFill.formId === '376319') {
						const submitButton = formEmbed.shadowRoot?.querySelector('button[type="submit"]');
						if (submitButton) {
							submitButton.style.marginTop = '10px';
							submitButton.style.marginBottom = '10px';
						}
					}

					const countrySelectorButton = formEmbed.shadowRoot?.querySelector('button[aria-controls="country-selector-dropdown"]');
					const countrySelectorParentDiv = formEmbed.shadowRoot?.querySelector('div[class^="_formPhoneInputContainer"]');

					if (countrySelectorButton) {
						countrySelectorButton.style.maxHeight = '50px';
					}

					if (countrySelectorParentDiv && window.innerWidth > 460) {
						countrySelectorParentDiv.style.gridTemplateColumns = 'minmax(0, 0.55fr) minmax(0, 2.2fr)';
					}

					setTimeout(() => {
						autoFill.fields.forEach(field => {
							const input = formEmbed.shadowRoot?.querySelector(`input[type="tel"]`);
							if (input) {
								input.blur(); // Remove focus from the input field
							}

							if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
								const formElements = formEmbed.shadowRoot?.querySelectorAll('input, button, select, textarea');
								formElements.forEach(element => {
									element.style.fontSize = '16px'; // prevent iOS form field zoom
								});
							}

						});
					}, 100);

					autoFill.fields.forEach(field => {
						const input = formEmbed.shadowRoot?.querySelector(`input[id="${field.fieldId}"]`);
						if (input) {
							input.value = field.value;
                          console.log(field.value);
							input.dispatchEvent(new Event('input', { bubbles: true }));

							if (field.isDisabled) {
								input.setAttribute('readonly', 'readonly');
								input.style.backgroundColor = '#e9ecef';
								input.style.cursor = 'not-allowed';

								input.addEventListener('keydown', (e) => e.preventDefault());
								input.addEventListener('paste', (e) => e.preventDefault());
							}
						}


						const checkboxes = formEmbed.shadowRoot?.querySelectorAll(`input[type="checkbox"]`);
						checkboxes.forEach(checkbox => {
							if (checkbox) {
								checkbox.style.cursor = 'pointer';
								const label = checkbox.closest('label');
								if (label) {
									label.style.cursor = 'pointer';
								}

								// if mobile, increase checkbox size and radio button size
								if (window.innerWidth <= 768) {
									checkbox.style.width = '18px';
									checkbox.style.height = '18px';
									checkbox.style.marginTop = '-3px';
								}
							}
						});

						const radioButtons = formEmbed.shadowRoot?.querySelectorAll(`input[type="radio"]`);
						radioButtons.forEach(radioButton => {
							if (radioButton) {
								radioButton.style.cursor = 'pointer';
								const label = radioButton.closest('label');
								if (label) {
									label.style.cursor = 'pointer';
								}

								// if mobile, increase checkbox size and radio button size
								if (window.innerWidth <= 768) {
									if (label) {
										label.style.gridTemplateColumns = '1.5em minmax(0, 1fr)';
									}

									if (radioButton) {
										radioButton.style.width = '18px';
										radioButton.style.height = '18px';
										radioButton.style.marginTop = '-3px';
									}
								}
							}
						});

					});
				}
			}, 100); // Adjust this timeout as needed
		}

	});

}

document.addEventListener('DOMContentLoaded', () => {
	const observer = new MutationObserver((mutations, obs) => {
		const formEmbeds = document.querySelectorAll('shopify-forms-embed');
		if (formEmbeds.length > 0) {
			// Wait for shadow DOM to be ready
			setTimeout(() => {
				const allFormsReady = Array.from(formEmbeds).every(embed => embed.shadowRoot);
				if (allFormsReady) {
					obs.disconnect();

					/** Adds the label override inside each Shopify Forms Shadow DOM. */
					formEmbeds.forEach(embed => {
						const shadow = embed.shadowRoot;
						if (shadow.getElementById('fixed-form-label-top')) return;

						const style = document.createElement('style');
						style.id = 'fixed-form-label-top';
						style.textContent = 'label[id^="label-"] { top: 18px !important; }';
						shadow.appendChild(style);
					});
					
					// Continue with form processing
					handleFormFills();
				}
			}, 100);
		}
	});

	observer.observe(document, {
		childList: true,
		subtree: true
	});
});
